export const formatDate = (dateString) => {
    // console.log('dateString formatDate', dateString);
    
    const date = new Date(dateString);

    // console.log('date formatDate', date);

    // Get day of the week
    const dayOfWeek = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(date);

    // console.log('dayOfWeek formatDate', dayOfWeek);

    // Get day, month, and year
    const day = new Intl.DateTimeFormat('en-US', { day: '2-digit' }).format(date);
    // console.log('day formatDate', day);
    const month = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(date);
    // console.log('month formatDate', month);
    const year = new Intl.DateTimeFormat('en-US', { year: 'numeric' }).format(date);
    // console.log('year formatDate', year);

    // Get time in 12-hour format
    const time = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    }).format(date);

    // console.log('time formatDate', time);

    return `${dayOfWeek}, ${day} ${month}, ${year} (${time})`;
};

export const formatDateShort = (dateString) => {
    if (!dateString) return '';

    // Legacy subscription expiryDate values were stored as "DD/MM/YYYY" strings.
    // Native Date parsing treats slash-separated dates as MM/DD/YYYY, which
    // silently swaps day and month (or fails outright when day > 12) - so
    // these need to be parsed explicitly rather than handed to `new Date()`.
    const legacyDDMMYYYY = typeof dateString === 'string' && dateString.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    const date = legacyDDMMYYYY
        ? new Date(Number(legacyDDMMYYYY[3]), Number(legacyDDMMYYYY[2]) - 1, Number(legacyDDMMYYYY[1]))
        : new Date(dateString);
    // Non-date text (e.g. "No replies", "N/A") should pass through unchanged
    // rather than being blanked out.
    if (isNaN(date.getTime())) return dateString;

    const day = new Intl.DateTimeFormat('en-US', { day: '2-digit' }).format(date);
    const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
    const year = new Intl.DateTimeFormat('en-US', { year: 'numeric' }).format(date);

    return `${day} ${month} ${year}`;
};

export const formatChatTime = (dateString) => {
    // console.log('dateString formatDate', dateString);
    
    const date = new Date(dateString);

    // console.log('date formatDate', date);

    // Get day of the week
    // const dayOfWeek = new Intl.DateTimeFormat('en-US', { weekday: 'short' }).format(date);

    // console.log('dayOfWeek formatDate', dayOfWeek);

    // Get day, month, and year
    const day = new Intl.DateTimeFormat('en-US', { day: '2-digit' }).format(date);
    // console.log('day formatDate', day);
    const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(date);
    // console.log('month formatDate', month);
    const year = new Intl.DateTimeFormat('en-US', { year: 'numeric' }).format(date);
    // console.log('year formatDate', year);

    // Get time in 12-hour format
    const time = new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    }).format(date);

    // console.log('time formatDate', time);

    return `${day} ${month}, ${year} (${time})`;
};


export default formatDate;
